module.exports = __webpack_public_path__ + "static/img/icon-right-menu.f3bcf77d.png";